"use client";

import ExpandIcon from "components/icons/expand.icon";
import { ReactNode, useState, useId } from "react";

const Expandable = ({
  title,
  className,
  children,
}: {
  title: string;
  className: string;
  children: ReactNode;
}) => {
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <div className={className ? "c-expandable " + className : "c-expandable"}>
      <button
        type="button"
        className="c-expandable-title"
        aria-expanded={open}
        aria-controls={id}
        onClick={() => setOpen(!open)}
      >
        <div className="c-expandable-title-text-element">{title}</div>
        <div
          className={open ? "c-expandable-icon--expanded" : "c-expandable-icon"}
          aria-hidden="true"
        >
          <ExpandIcon />
        </div>
      </button>
      {/* Innholdet står alltid i DOM og styres kun med hidden-attributt. Det
          lar ctrl+F finne medlemmer på tvers av lukkede ekspandere, og gjør
          :has-selector i CSS forutsigbar (open vs closed via aria-expanded). */}
      <div id={id} className="c-expandable-content" hidden={!open}>
        {children}
      </div>
    </div>
  );
};

export default Expandable;
